import * as React from "react";

const SvgVolumeup = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M15.536 8.466a5 5 0 0 1 0 7.071M18.364 5.638a9 9 0 0 1 0 12.728M5.586 15.002H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1.586l4.707-4.707c.63-.63 1.707-.184 1.707.707v14c0 .891-1.077 1.337-1.707.707l-4.707-4.707Z" />
    </g>
  </svg>
);

export default SvgVolumeup;
